import { useEffect, useState } from 'react'

const LEGAL_ACCEPTANCE_KEY = 'investfacil-legal-accepted-v1'
const THEME_MODE_KEY = 'investalbum-theme-mode-v1'
const ALBUM_PAGE_SIZE_KEY = 'investalbum-album-page-size-v1'
const ALBUM_PAGE_SIZE_OPTIONS = [25, 50, 100] as const

export function useAppPreferences() {
  const [isLegalAccepted, setIsLegalAccepted] = useState<boolean>(() => {
    try {
      return window.localStorage.getItem(LEGAL_ACCEPTANCE_KEY) === 'yes'
    } catch {
      return false
    }
  })
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    try {
      const storedTheme = window.localStorage.getItem(THEME_MODE_KEY)
      return storedTheme === null ? true : storedTheme === 'dark'
    } catch {
      return true
    }
  })
  const [albumPageSize, setAlbumPageSize] = useState<number>(() => {
    try {
      const raw = Number(window.localStorage.getItem(ALBUM_PAGE_SIZE_KEY))
      if (ALBUM_PAGE_SIZE_OPTIONS.includes(raw as (typeof ALBUM_PAGE_SIZE_OPTIONS)[number])) {
        return raw
      }
    } catch {
      // non-fatal
    }
    return ALBUM_PAGE_SIZE_OPTIONS[0]
  })

  useEffect(() => {
    const cls = 'theme-dark'
    document.body.classList.toggle(cls, isDarkMode)
    try {
      window.localStorage.setItem(THEME_MODE_KEY, isDarkMode ? 'dark' : 'light')
    } catch {
      // non-fatal
    }
  }, [isDarkMode])

  useEffect(() => {
    try {
      window.localStorage.setItem(ALBUM_PAGE_SIZE_KEY, String(albumPageSize))
    } catch {
      // non-fatal
    }
  }, [albumPageSize])

  function acceptLegalTerms(): void {
    setIsLegalAccepted(true)
    try {
      window.localStorage.setItem(LEGAL_ACCEPTANCE_KEY, 'yes')
    } catch {
      // non-fatal
    }
  }

  return {
    isLegalAccepted,
    isDarkMode,
    setIsDarkMode,
    albumPageSize,
    setAlbumPageSize,
    acceptLegalTerms
  }
}
